const EXAM_MODULES = {
  ABDOMEN: { key: 'ABDOMEN', name: 'Abdômen' },
  BRAIN: { key: 'BRAIN', name: 'Cérebro' },
  CHEST: { key: 'CHEST', name: 'Peito' },
  LUNG: { key: 'LUNG', name: 'Pulmão' },
  TORAX: { key: 'TORAX', name: 'Tórax' },
  OUTROS: { key: 'OUTROS', name: 'Outros' }
};

export default EXAM_MODULES;
